import React, { useRef, useCallback } from 'react';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import * as Yup from 'yup';

import Grid from '@material-ui/core/Grid';
import getValidationError from '../../../utils/getValidationsErros';

/** hooks */
import { useHttp } from '../../../hooks/http';

/** componentes */
import {
  WrapperLabel, Select, Button, Input, TextArea,
} from '../../../components/Forms';

import { Container } from './styles';

/** interface */
import { IService } from '../../../interfaces';

interface IStarted {
  service: IService | null;
  sectors: {value: number, label: string}[] | null;
  handleStatus(id:any):void;
}

const Started: React.FC<IStarted> = ({ service, sectors, handleStatus }) => {
  const formRef = useRef<FormHandles>(null);
  const { httpPost, loading } = useHttp();
  const handleSubmit = useCallback(async (payload: any) => {
    const _service = {
      ...payload,
      id: service?.id,
      sector_id: payload?.sector_id?.value,
      body_cam: payload?.body_cam,
    };
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        sector_id: Yup.string().ensure().required('o Setor é obrigatório'),
      });

      await schema.validate(_service, { abortEarly: false });

      const { status, data } = await httpPost('services/presence/to-started', _service);
      if (status === 200) {
        handleStatus(data);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
      formRef.current?.setErrors(erros);
      }
    }
  }, [handleStatus, httpPost, service]);

  return (
    <Container>
      <UForm ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <WrapperLabel label="Agente" xs={12}>
            <Input name="agente" defaultValue={service?.user} readOnly />
          </WrapperLabel>
          <WrapperLabel label="Setor" xs={12}>
            <Select name="sector_id" options={sectors || undefined} />
          </WrapperLabel>
          <WrapperLabel label="BodyCam" xs={12}>
            <Input name="body_cam" />
          </WrapperLabel>
          <WrapperLabel label="Alterações" xs={12}>
            <TextArea name="description" row={3} />
          </WrapperLabel>
        </Grid>
        <Grid container justify="flex-end">
          <Grid item xs={12}>
            <Button type="submit" isLoading={loading}>Confirmar presença</Button>
          </Grid>
        </Grid>
      </UForm>
    </Container>
  );
};

export default Started;
